<template>
  <div class="editor-module-list">
    <div v-if="moduleList.base" class="module-type" @click="moduleListToggle">
      <span>基础组件 ({{ moduleList.base.length }})</span>
      <i class="el-icon-arrow-down module-drapdown"></i>
    </div>
    <draggable
      v-if="moduleList.base"
      class="module-list"
      :list="moduleList.base"
      :options="draggableOptions.module"
      :clone="cloneHandler"
      @end="cloneEndHandler"
    >
      <div
        class="module-item"
        v-for="mod in moduleList.base"
        :data-track="
          JSON.stringify({
            t: '0001', 
            options: {
              ...mod, 
            },
          })
        "
        @click="addMod(mod)"
      >
        <i class="iconfont" :class="mod.icon" v-html="mod.font_icon"></i><br />
        {{ mod.name }}
      </div>
    </draggable>
    <div
      v-if="moduleList.business"
      class="module-type"
      @click="moduleListToggle"
    >
      <span>营销组件 ({{ moduleList.business.length }})</span>
      <i class="el-icon-arrow-down module-drapdown"></i>
    </div>
    <draggable
      v-if="moduleList.business"
      class="module-list"
      :list="moduleList.business"
      :options="draggableOptions.module"
      :clone="cloneHandler"
      @end="cloneEndHandler"
    >
      <div
        class="module-item"
        v-for="mod in moduleList.business"
        :data-track="
          JSON.stringify({
            t: '0002', 
            options: {
              ...mod, 
            },
          })
        "
        @click="addMod(mod)"
      >
        <i class="iconfont" :class="mod.icon" v-html="mod.font_icon"></i><br />
        {{ mod.name }}
      </div>
    </draggable>
    <div
      v-if="moduleList.activeList"
      class="module-type"
      @click="moduleListToggle"
    >
      <span>商品玩法 ({{ moduleList.activeList.length }})</span>
      <i class="el-icon-arrow-down module-drapdown"></i>
    </div>
    <draggable
      v-if="moduleList.activeList"
      class="module-list"
      :list="moduleList.activeList"
      :options="draggableOptions.module"
      :clone="cloneHandler"
      @end="cloneEndHandler"
    >
      <div
        class="module-item"
        v-for="mod in moduleList.activeList"
        :data-track="
          JSON.stringify({
            t: '0003', 
            options: {
              ...mod, 
            },
          })
        "
        @click="addMod(mod)"
      >
        <i class="iconfont" :class="mod.icon" v-html="mod.font_icon"></i><br />
        {{ mod.name }}
      </div>
    </draggable>
  </div>
</template>

<style lang="scss" scoped>
.dnd-placeholder {
  width: 100%;
  height: 45px;
  background: url(../../../assets/placeholder.png) no-repeat center;
  background-size: cover;
  text-indent: -9999em;

  * {
    display: none;
  }
}

.editor-module-list {
  font-size: 0px;
  text-align: center;

  .module-type {
    font-size: 14px;
    color: #666;
    padding: 16px 0 0 16px;
    cursor: pointer;

    span {
      padding-right: 12px;
    }

    .module-drapdown {
      font-size: 14px;
      color: #c0c4cc;
      font-weight: bold;
      transition: transform 0.3s;
    }

    &.hide {
      .module-drapdown {
        transform: rotate(-90deg);
      }
    }
  }

  .module-list {
    display: flex;
    flex-wrap: wrap;
    transition: max-height 0.3s ease-in-out;
    max-height: 1600px;
  }

  .module-type.hide + .module-list {
    max-height: 0px;
    overflow: hidden;
  }

  .module-item {
    cursor: pointer;
    text-align: center;
    width: 87px;
    flex: 0 0 87px;
    height: 87px;
    margin: 16px 0 0 10px;
    background: #f9f9f9;
    border-radius: 4px;
    border: 1px solid #e3e7ee;
    font-size: 14px;
    padding-top: 22px;
    line-height: 20px;
    &:hover {
      color: #fff;
      background: #306eed;
    }
    i {
      font-size: 24px;
    }
  }
}
</style>

<script>
import draggable from "vuedraggable";
import { addClass, removeClass, hasClass } from "@/js/dom";
import { tmsMixin } from "@/js/common/mixin";
import _ from "lodash";

export default {
  data() {
    return {
      draggableOptions: {
        // 左侧模块列表拖拽配置
        module: {
          group: {
            name: "module",
            pull: "clone",
            put: false,
          },
          sort: false,
          ghostClass: "dnd-placeholder",
        },
      },
    };
  },
  mixins: [tmsMixin],
  props: ["pageData", "moduleList"],
  components: {
    draggable,
  },
  watch: {
    /* 处理组件显示 */
  },
  mounted() {},

  methods: {
    // 添加组件
    addMod(mod) {
      this.$emit("addMod", mod);
    },
    cloneHandler(item) {
      if (this.checkModuleListAdd(item)) {
        console.log(item);

        return _.cloneDeep(item);
      }
    },
    cloneEndHandler(event) {
      this.$emit("cloneEndHandler", event);
    },
    // 组件列表收缩
    moduleListToggle(event) {
      if (hasClass(event.currentTarget, "hide") === true) {
        removeClass(event.currentTarget, "hide");
      } else {
        addClass(event.currentTarget, "hide");
      }
    },
  },
};
</script>
